import React from 'react';
import type { FilterMainComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import { FilterRadio } from '@/app/common/filters/types/radio/FilterRadio.tsx';
import OvernightFlightsMessage from '@/app/components/search/components/OvernightFlightsMessage';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';

export const FilterOvernightFlights = ({ filter, isLoading, handleFilterChanged }: FilterMainComponentProps) => {
  const { localization } = usePageWrapperData();

  return (
    <>
      <OvernightFlightsMessage localization={localization} style={{ margin: 0 }} />
      <FilterRadio filter={filter} isLoading={isLoading} handleFilterChanged={handleFilterChanged} />
    </>
  );
};
